import { Medium } from "@bkry/bowline-components/Medium";
import { getCommunityAnnouncementAttributes } from "@bkry/bowline-redux/communityAnnouncements";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardBody, CardTitle } from "reactstrap";

const CommunityAnnouncementCard = (props, context) => {
  const { communityAnnouncementId } = props;

  const communityAnnouncement = useSelector((state) =>
    getCommunityAnnouncementAttributes(state, communityAnnouncementId)
  );

  const lang = useSelector((state) => state.i18nState.lang);

  return (
    <Card className="unlockablecontentcard h-100 mb-3">
      <div className="ratio ratio-16x9 card-img-top overflow-hidden">
        {communityAnnouncement?.public_medium_thumbnail &&
          communityAnnouncement?.public_medium_metadata && (
            <Medium
              mediumData={{
                ...communityAnnouncement?.public_medium_thumbnail,
                ...communityAnnouncement?.public_medium_metadata,
              }}
              altTitle={communityAnnouncement?.title}
            />
          )}
      </div>
      <CardBody className="d-flex flex-column">
        <CardTitle className="h6">{communityAnnouncement?.title}</CardTitle>
        <CardBody>
          <p className="small">{communityAnnouncement?.preview_description}</p>
        </CardBody>
        <div className="d-flex mt-auto">
          <Link
            to={`/${lang}/news/${communityAnnouncementId}`}
            className="ms-auto btn btn-sm btn-primary stretched-link"
          >
            {context.t("Details")}
          </Link>
        </div>
      </CardBody>
    </Card>
  );
};

/**  define proptypes for CommunityAnnouncementCard  */
CommunityAnnouncementCard.propTypes = {
  communityAnnouncementId: PropTypes.string.isRequired,
};

/**  define defaultProps for CommunityAnnouncementCard  */
CommunityAnnouncementCard.defaultProps = {};

/**  define proptype for the 'translation' function  */
CommunityAnnouncementCard.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default CommunityAnnouncementCard;
